<mat-toolbar class="main-header">
    <div class="header-container">
        <!-- Active Page Label -->
        <div class="header-block active-page-block">
            <mat-icon>{{ navigationService.activeItem().icon }}</mat-icon>
            @if (settingsTitleKey() !== null) {
            {{ settingsTitleKey()! | translate }}
            } @else {
            {{ ('app.navigation.primary_nav.label.' + navigationService.activeItem().label | translate) | titlecase
            }}
            }
        </div>

        <!-- Actions Block -->
        <div class="header-block actions-block gap-3">

            <!-- User Info Group -->
            @if (currentUser$ | async; as user) {
            <div class="user-profile-group">
                <av-avatar [name]="user.displayName ?? user.name" [photoUrl]="user.photo" size="sm"></av-avatar>
                <span class="user-info-block" (click)="copyToClipboard(user.userPrincipalName, emailTooltip)"
                    [matTooltip]="copyFeedbackTooltip() ?? (currentUser$ | async)?.userPrincipalName"
                    #emailTooltip="matTooltip">
                    <span class="username">{{ user.displayName }}</span>
                    <span class="user-mail text-truncate">{{ user.userPrincipalName }}</span>
                </span>

                <button mat-icon-button class="copy-email-btn"
                    (click)="copyToClipboard(user.userPrincipalName, copyTooltip)"
                    [matTooltip]="copyFeedbackTooltip() ?? (translationService.instant('shared.general.tooltips.copy_email_tooltip.default'))"
                    matTooltipClass="copy-tooltip" #copyTooltip="matTooltip">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
            }

            <div class="actions-divider"></div>

            <!-- Settings / Logout -->
            @switch (ParentRoute()) {
            @case ('settings') {
            <a [routerLink]="getBackFromSettingsUrl()">
                <mat-icon [matTooltip]="'app.main_header.workspace-switcher.home_tooltip' | translate"
                    class="workspace-switcher">home</mat-icon>
            </a>
            }
            @default {
            @if (hasSettingsAccess()) {
            <a routerLink="/settings">
                <mat-icon [matTooltip]="'app.main_header.workspace-switcher.settings_tooltip' | translate"
                    class="workspace-switcher">settings</mat-icon>
            </a>
            } @else {
            <a (click)="confirmLogout()">
                <mat-icon [matTooltip]="'app.main_header.workspace-switcher.logout_tooltip' | translate"
                    class="workspace-switcher logout">logout</mat-icon>
            </a>
            }
            }
            }

            <div class="actions-divider"></div>

            <!-- Language Switcher -->
            <av-language-dropdown></av-language-dropdown>
        </div>

    </div>
</mat-toolbar>